import { render } from "./NotApplicable.vue?vue&type=template&id=77533e34&scoped=true&ts=true"
import script from "./NotApplicable.vue?vue&type=script&lang=ts"
export * from "./NotApplicable.vue?vue&type=script&lang=ts"

import "./NotApplicable.vue?vue&type=style&index=0&id=77533e34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77533e34"]])

export default __exports__